export default __webpack_public_path__ + "static/media/NoRacesMascot.d3ce3f4b.png";